import { useMutation } from 'react-query';

import { axios } from '@/library/axios';
import type { BaseResponse, Paginated } from '@/types';

import type { CustomerLoan } from './types';

const fetchCustomerLoans = async (
  customerId: string
): Promise<CustomerLoan[]> => {
  const res = await axios<
    Paginated<CustomerLoan[]>,
    BaseResponse<Paginated<CustomerLoan[]>>,
    void
  >({
    url: `/customers/${customerId}/loans?isTopupExcluded=true`,
    method: 'post',
  });

  return res.data.data.content;
};

export const useAllCustomerLoans = () => {
  const { mutateAsync, data, isLoading } = useMutation(fetchCustomerLoans);

  return { fetchCustomerLoans: mutateAsync, data, isLoading };
};
